// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-1xoFd","header":"header-3R3T1","title":"title-1DW7m","description":"description-1b9Wp"};